export type TranscriptMessage = {
  timestamp?: string;
  speaker: 'HUMAN' | 'BOT';
  message: string;
};

export const parseTranscript = (transcript: string): TranscriptMessage[] => {
  if (!transcript) return [];

  const lines = transcript.split('\n').filter((line) => line.trim());
  const messages: TranscriptMessage[] = [];

  lines.forEach((line) => {
    const match = line.match(/^\[([^\]]+)\]\s*(HUMAN|BOT):\s*(.+)$/);
    if (match) {
      messages.push({
        timestamp: match[1],
        speaker: match[2] as 'HUMAN' | 'BOT',
        message: match[3].trim(),
      });
    }
  });

  return messages;
};
